<template lang="pug">
  v-tabs(
    v-model="activeTab"
    hide-slider
    class="e-tabs"
  )
    v-tab(
      v-for="(tab, idx) in items"
      :key="idx"
      class="e-tabs__item"
      active-class="e-tabs__item--active"
    ) {{ tab.text }}
    v-tabs-items(v-model="activeTab")
      v-tab-item(
        v-for="(tab, idx) in items"
        :key="idx"
      )
        component(
          :is="tab.component"
          v-bind="tab.componentProps"
          :loading="loading"
          @goToTab="activeTab = $event"
        )
</template>

<script>
import BlockDocumentGeneralInfo from '~/modules/documents/components/blocks/admin/block-document-general-info'
import BillingOverview from '~/modules/billing/components/billing-overview'
import BillingPlans from '~/modules/billing/components/billing-plans'
import BillingInvoices from '~/modules/billing/components/billing-invoices'
import BillingActs from '~/modules/billing/components/billing-acts'
import BlockProfileData from '~/modules/profile/components/block-profile-data'
import BlockProfileApiKeys from '~/modules/profile/components/block-profile-api-keys'
import BlockDocumentParticipants from '~/modules/documents/components/blocks/admin/block-document-participants'
import BlockDocumentSignatures from '~/modules/documents/components/blocks/admin/block-document-signatures'
import MDocumentEventLog from '~/modules/documents/components/modules/pro-version/m-document-event-log'
import BlockUserSessions from '~/modules/users/components/blocks/block-user-sessions'
import BlockAdminTemplates from '~/components/modules/blocks/admin/block-admin-templates'
import BlockUserTags from '~/modules/users/components/blocks/block-user-tags'
import BlockUserOrganizations from '~/modules/users/components/blocks/block-user-organizations'
import BlockDocumentLogs from '~/modules/documents/components/blocks/admin/block-document-logs'
import BlockOrganizationBilling from '~/modules/organizations/components/admin/block-organization-billing'
import BlockOrganizationActs from '~/modules/organizations/components/admin/block-organization-acts'
import BlockOrganizationInvoices from '~/modules/organizations/components/admin/block-organization-invoices'
import BlockOrganizationPayments from '~/modules/organizations/components/admin/block-organization-payments'
import BlockOrganizationPeriods from '~/modules/organizations/components/admin/block-organization-periods'
import BlockAdminDocuments from '~/components/modules/blocks/admin/block-admin-documents'
import BlockTemplateGeneralInfo from '~/modules/templates/components/blocks/admin/block-template-general-info'
import BlockDocumentStatuses from '~/modules/documents/components/blocks/admin/block-document-statuses'
import BlockAdminUsers from '~/components/modules/blocks/admin/block-admin-users'
import BlockProfileEdsKeys from '~/modules/profile/components/block-profile-eds-keys'

export default {
  name: 'ETabs',
  components: {
    BillingInvoices,
    BillingPlans,
    BillingOverview,
    BillingActs,
    BlockProfileData,
    BlockProfileApiKeys,
    BlockDocumentGeneralInfo,
    BlockDocumentParticipants,
    BlockDocumentSignatures,
    MDocumentEventLog,
    BlockUserSessions,
    BlockAdminTemplates,
    BlockUserTags,
    BlockUserOrganizations,
    BlockDocumentLogs,
    BlockOrganizationBilling,
    BlockOrganizationActs,
    BlockOrganizationInvoices,
    BlockOrganizationPayments,
    BlockOrganizationPeriods,
    BlockAdminDocuments,
    BlockTemplateGeneralInfo,
    BlockDocumentStatuses,
    BlockAdminUsers,
    BlockProfileEdsKeys
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0
    }
  },
  watch: {
    activeTab(index) {
      this.$emit('activeTabIdx', index)
    }
  }
}
</script>

<style lang="scss">
.e-tabs {
  overflow-x: auto;

  &.shrinked {
    width: auto !important;
    flex: 0 0 auto !important;
  }

  &__item {
    border-radius: 9999px;
    border: 1px solid $border-gray;

    font-size: 12px;
    font-weight: 400;
    color: $text-dark !important;

    height: 32px;

    &:not(:last-child) {
      margin-right: 8px;
    }

    &:before {
      border-radius: 9999px;
    }

    &--active {
      background: $primary-light;
      border: none;
      color: $primary !important;
    }
  }
}
</style>
